import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "./Logo";

export const ThankYouSignoff = ({ standalone = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.4, duration: 0.6 }}
    className={
      standalone
        ? "flex flex-col items-center"
        : "mt-12 pt-10 border-t border-[#111111]/10 flex flex-col items-center"
    }
    data-testid="thank-you-signoff"
  >
    <Logo className={standalone ? "h-20 w-auto" : "h-14 w-auto"} />
    <p
      className={`mt-5 font-display font-black uppercase tracking-tight leading-snug text-[#111111] ${
        standalone ? "text-2xl md:text-3xl" : "text-lg"
      }`}
    >
      We at <span className="text-[#FF4500]">12-0Clock Moto Co</span> highly
      appreciate your business,
    </p>
    <p className="text-[#555555] text-sm mt-1.5 uppercase tracking-widest">
      we hope to see you again!
    </p>
  </motion.div>
);

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-[#ECECE8] flex flex-col">
      <div className="noise-overlay" />
      <div className="p-6">
        <Link to="/" data-testid="thankyou-home-link">
          <Logo />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-5">
        <div className="text-center max-w-lg" data-testid="thankyou-page">
          <ThankYouSignoff standalone />
          <Link
            to="/#store"
            data-testid="thankyou-store-link"
            className="mt-10 inline-flex items-center gap-2 bg-[#FF4500] text-white px-7 py-3.5 rounded-sm font-black uppercase text-sm tracking-wider hover:bg-[#111111] transition-colors"
          >
            Back to Store <ArrowRight className="h-4 w-4" />
          </Link>
          <div
            className="mt-10 flex w-fit mx-auto items-center gap-3 bg-white border border-[#111111]/15 rounded-sm px-3 py-2"
            data-testid="thankyou-qr-code"
            title="Scan to open 12-0clock.com"
          >
            <img
              src="/qr-12oclock.png"
              alt="QR code linking to 12-0clock.com"
              className="h-14 w-14"
            />
            <div className="text-black text-left">
              <p className="text-[9px] font-black uppercase tracking-widest leading-tight">
                Share with friends
              </p>
              <p className="text-[10px] font-black uppercase tracking-wider leading-tight">
                12-0clock.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
